import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import {Box} from '@mui/material';
import {  memo  , useCallback , useState , useRef} from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import { useTranslation } from "react-i18next";
import {getImagePaths , slickSettingsCard} from "../../components/constants.js";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import SlackImage from "..//modal/slackImage.js";
import { useAudio }  from "../../hooks/useAudio.ts";
import ShareButtonX from "..//button/ShareButtonX.js";
import LinkCopyButton from "..//button/LinkCopyButton.js";
import {getLink} from "../../utils/UrlUtil.js";

const MapCardFlower = memo((props) => {
    const {flower , resetMarker , isNarrowDown , toggleNarrowDown , modalOpen} = props;
    const [isOpenDescription , setIsOpenDescription] = useState(false);
    const { t } = useTranslation();

    //--- 画像モーダル
    const [showModal , setShowModal] = useState(false);
    const selectedSlackImgUrl = useRef(null);
    const openSlackModal = (index, url) => {
        selectedSlackImgUrl.current = url;
        setShowModal(true);
    };
    const closeSlackModal = (index, url) => {
        selectedSlackImgUrl.current = "";
        setShowModal(false);
    };
    // 画像モーダル ---*/

     //---- 音声ガイド　---
     const { playSound, stopSound, currentAudioSrc } = useAudio();   

    const toggleOpenDescription = () => {
        setIsOpenDescription(!isOpenDescription);
    };
    const close = () => {
        setIsOpenDescription(false);
        stopSound();
        resetMarker();
    }
    const clickBtnNarrow = () => {
        toggleNarrowDown(!isNarrowDown);
    }

    const nl2comma = useCallback((str) => {
        return str.replaceAll("¥/", "、");
    },[]);

    const canDisplayDescription = useCallback((flower) => {
        if(!flower){
            return false;
        }
        return flower.description !== '';
    },[]);

    const soundStart = () => {
        let src = "/assets/sound/" + flower.sound;
        playSound(src);
    };
    const soundStop = () => {
        stopSound();
    };
    const isPlayingSound = (history) => {
        return currentAudioSrc != ""
    }


    if(flower && flower.name){
    let paths = getImagePaths(flower.path);
    return <>
    <Card className={"flowerCard mapCard"} sx={{
       position: 'absolute',
       bottom: '1%',
       right:'1%',
       width:'98%',
       zIndex:10000    
    }}>
    <Box className='head-content'>
        <Typography component="div" variant="h5" className="title">
            {flower.name}
        </Typography>
        <IconButton className={"close"} size="large">
            <CloseIcon onClick={close} />
        </IconButton>
    </Box>
    <Box className="share-button-row">
        <span className='category-label text'>{t("category." + flower.category)}</span>
        <div className="img-wap">
            <ShareButtonX 
                path={getLink(flower)}
                text={flower.name + ' / ' + t("meta.title")}
            />
            <LinkCopyButton 
                path={getLink(flower)}
            />
        </div>
    </Box>
    <hr className={"hr95"} />
    {!isNarrowDown &&
    <Box sx={{display:'flex'}}>
        <Box sx={{ display: 'block'}}>
            <CardContent className="card-content" sx={{ flex: '1 0 auto' }}>  
                <div className="slick-wrap">
                    {paths.length >= 1 &&
                    <Slider {...slickSettingsCard}>
                    {
                        paths.map((path, index) =>{        
                            return <Box className="img-carousel-wrap" key={index} onClick={() => openSlackModal(index, "/assets/images/descriptions/" + path)}>
                                <img className="img-carousel" src={"/assets/images/descriptions/" + path} />
                                </Box>
                        })
                    }
                    </Slider>
                    }
                </div>
                <Typography component="div" className="subtitle">
                    {t("nature.card.area")}：{nl2comma(flower.area)}
                </Typography>
                
                <Typography  component="div" className="subtitle">
                    {t("nature.card.season")}：{flower.seasons.period}
                </Typography> 

                {(flower.insta360 || flower.sound) && 
                <Box className='btnWrap'>
                    {flower.insta360 && 
                    <Button variant="contained" onClick={modalOpen}>{t("360image.button")}</Button>
                    }
                    {flower.sound && 
                    <>
                    {isPlayingSound(flower)? (
                        <Button variant="contained" onClick={soundStop}>停止</Button>
                    ) : (
                        <Button variant="contained" onClick={soundStart}>音声ガイド</Button>
                    )}
                    </>
                    }
                </Box>
                }

                {canDisplayDescription(flower.description) && !isNarrowDown &&
                <>
                <hr className={"hr98 mtb10"} />
                <Box className='description'>
                    {flower.description}
                </Box>
                </>
                }
            </CardContent>
        </Box>
    </Box>
    }

    <Box className='btnWrap'>
        <Button variant="contained" onClick={clickBtnNarrow}>
            {isNarrowDown?<>{t("common.btn_narrow_off")}</>:<>{t("common.btn_narrow_on")}</>}
        </Button>
        {
        //詳細ボタンは常に非表示
        false && canDisplayDescription(flower.description) && !isNarrowDown &&
        <Button variant="outlined" onClick={toggleOpenDescription}>
            {isOpenDescription?<>{t("common.btn_close_detail")}</>:<>{t("common.btn_open_detail")}</>}
        </Button>
        }
    </Box>
    {showModal &&
        <SlackImage isOpen={showModal} modalClose={closeSlackModal} url={selectedSlackImgUrl.current}></SlackImage>
    }
    </Card>       
    </>;
    }
});
export default MapCardFlower
